<template >
    <div >
        <div class="flex items-center justify-between" >
            <div class="text-sm font-semibold text-gray-900" >Tags verwalten</div >
            <button type="button" @click="createTag" v-if="tags.length < 25"
                    class="rounded-md bg-secondary px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-secondary-dark" >
                Tag anlegen
            </button >
        </div >

        <div class="mt-4" v-if="tags.length">
            <div class="space-y-2">
                <div v-for="(tag, index) in tags" :key="index"
                     class="flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3">

                    <!-- View mode -->
                    <template v-if="editTagIndex !== index && tags[index].id">
                        <div class="h-4 w-4 rounded-full shrink-0 border border-gray-200"
                             :style="`background-color: ${tag.color};`"></div>
                        <span class="flex-1 text-sm text-gray-900">{{ tag.name }}</span>
                        <button type="button" @click="editSelectedTag(index)"
                                class="text-xs text-gray-400 hover:text-secondary transition-colors">
                            Bearbeiten
                        </button>
                        <button v-if="confirmDeleteIndex !== index" type="button" @click="confirmDeleteIndex = index"
                                class="text-xs text-gray-400 hover:text-primary transition-colors">
                            Löschen
                        </button>
                        <span v-if="confirmDeleteIndex === index" class="flex items-center gap-2">
                            <button type="button" @click="deleteSelectedTag(index)"
                                    class="text-xs text-primary font-medium">Wirklich löschen?</button>
                            <button type="button" @click="confirmDeleteIndex = null"
                                    class="text-xs text-gray-400">Abbrechen</button>
                        </span>
                    </template>

                    <!-- Edit / Create mode -->
                    <template v-if="editTagIndex === index || !tags[index].id">
                        <input type="color" v-model="tag.color"
                               class="h-8 w-8 rounded border-0 p-0 cursor-pointer shrink-0" />
                        <div class="flex-1">
                            <input type="text" v-model="tag.name" @keydown="checkNameLength"
                                   class="block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary sm:text-sm"
                                   :placeholder="'Tagname (max. 20 Zeichen)'" />
                        </div>
                        <button v-if="tags[index].id" type="button" @click="updateSelectedTag(index)"
                                class="text-xs text-secondary font-medium hover:text-secondary-dark transition-colors">
                            Speichern
                        </button>
                        <button v-if="!tags[index].id" type="button" @click="storeSelectedTag(index)"
                                class="text-xs text-secondary font-medium hover:text-secondary-dark transition-colors">
                            Anlegen
                        </button>
                        <button type="button" @click="tags[index].id ? cancelEditingTag(index) : removeEmptyTag(index)"
                                class="text-xs text-gray-400 hover:text-gray-600 transition-colors">
                            Abbrechen
                        </button>
                    </template>
                </div>
            </div>
        </div>

        <div v-else class="mt-6 text-center py-8">
            <p class="text-sm text-gray-400">Noch keine Tags angelegt.</p>
        </div>
    </div >
</template >

<script >
import Cookies from "js-cookie";

export default {
    data() {
        return {
            editTagIndex: false,
            confirmDeleteIndex: null,
            tags: [],
        };
    },

    methods: {
        fetchTags() {
            Cookies.set('tags', JSON.stringify([]), {expires: 1, path: ''});
            axios.get('/api/tags')
                .then(response => {
                    this.tags = response.data;
                    Cookies.set('tags', JSON.stringify(this.tags), {expires: 1, path: ''});
                });
        },

        createTag() {
            this.tags = [{
                id: null,
                name: '',
                color: '#06B6D4',
            }].concat(this.tags);
        },

        editSelectedTag(tagIndex) {
            this.editTagIndex = tagIndex;
            this.confirmDeleteIndex = null;
        },

        storeSelectedTag(tagIndex) {
            axios
                .post('/api/tags/', {
                    name: this.tags[tagIndex].name,
                    color: this.tags[tagIndex].color,
                })
                .then(response => {
                    this.fetchTags();
                    this.editTagIndex = false;
                    window.$toast?.show('Tag angelegt');
                });
        },

        updateSelectedTag(tagIndex) {
            axios
                .patch('/api/tags/' + this.tags[tagIndex].id, {
                    name: this.tags[tagIndex].name,
                    color: this.tags[tagIndex].color,
                })
                .then(response => {
                    this.fetchTags();
                    this.editTagIndex = false;
                    window.$toast?.show('Tag aktualisiert');
                });
        },

        deleteSelectedTag(tagIndex) {
            axios
                .delete('/api/tags/' + this.tags[tagIndex].id)
                .then(response => {
                    this.confirmDeleteIndex = null;
                    this.fetchTags();
                    window.$toast?.show('Tag gelöscht');
                });
        },

        removeEmptyTag(tagIndex) {
            this.tags.splice(tagIndex, 1);
        },

        cancelEditingTag(tagIndex) {
            this.editTagIndex = false;
            this.fetchTags();
        },

        checkNameLength(event) {
            if (event.target.value.length > 19) {
                if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                    return;
                }
                event.preventDefault();
            }
        },
    },

    mounted() {
        this.fetchTags();
    }
}
</script >
